<template>
  <div
    class="custom-scrollbar cusscrollbar text-noselect"
    :class="`cusscrollbar_${direction}`"
    @touchstart="handleTouchstart"
    @mousedown="handleMousedown"
    @wheel.stop="e => wheelScroll(e)"
  >
    <div class="cusscrollbar_inner-on-top">
      <slot name="back"></slot>
    </div>
    <div class="cusscrollbar_inner-wrapper">
      <div
        ref="cont"
        class="cusscrollbar_inner"
      >
        <slot name="handle_wrapper"></slot>

        <div
          v-if="hasHandle"
          ref="handle"
          class="cusscrollbar_handle"
          :style="handleStyle"
        >
          <slot name="handle"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'CustomScrollbar',
  props: {
    direction: { default: () => 'vertical' },
    percent: { default: () => 0 },
    hasHandle: { default: () => true },
    // direction: { default: () => 'horizontal' },
  }, 
 emits: ['update'],
  data() {
    return {
      mousedown: false,
      clientX: 0,
      clientY: 0,
      percentX: 0,
      percentY: 0,
    }
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  watch: {
    percent(n) {
      const { width, height, top, left } = this.$refs.cont.getBoundingClientRect()
      if (this.direction === 'horizontal') {
        this.clientX = width * n + left
        this.percentX = n < 0 ? 0 : n > 1 ? 1 : n
      } else {
        this.clientY = height * n + top
        this.percentY = n < 0 ? 0 : n > 1 ? 1 : n
      }
    },
  },
  methods: {
    handleMouseup() {
      this.mousedown = false
      this.removeEventListeners()
    },
    removeEventListeners() {
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('mousemove', this.handleMousemove)
      window.removeEventListener('touchend', this.handleMousemove)
      window.removeEventListener('touchmove', this.handleMouseup)
    },
    handleTouchstart(e) {
      this.mousedown = true
      this.moveHandle(e)
      window.addEventListener('touchend', this.handleMouseup)
      window.addEventListener('touchmove', this.handleMousemove)
    },
    handleMousedown(e) {
      this.mousedown = true
      this.moveHandle(e)
      window.addEventListener('mouseup', this.handleMouseup)
      window.addEventListener('mousemove', this.handleMousemove, { passive: false })
    },
    wheelScroll(e) {
      e.preventDefault()
      this.moveHandle(e)
    },
    handleMousemove: throttle(function (e) {
      if (this.mousedown) {
        this.moveHandle(e)
      }
    }, 1),
    moveHandle(e) {
      const coordinates = this.getCoordinates(e)
      const { clientY, clientX, percentX, percentY } = coordinates
      if (this.direction === 'horizontal') {
        this.clientX = clientX
        this.percentX = percentX
      } else {
        this.clientY = clientY
        this.percentY = percentY
      }

      this.$emit('update', coordinates)
    },
    getCoordinates(e) {
      const { y, x, width, height, bottom, right } = this.$refs.cont.getBoundingClientRect()

      let { clientX, clientY } = e
      if (e?.touches) {
        clientX = e?.touches[0]?.clientX
        clientY = e?.touches[0]?.clientY
      }
      if (e.deltaY || e.deltaX) {
        // clientX = e.deltaX + this.clientX
        // clientY = e.deltaY + this.clientY
        if (this.direction === 'horizontal') {
          clientX = (Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX) + this.clientX
        } else {
          clientY = e.deltaY + this.clientY
        }
      }

      let pixelY = clientY - y
      let pixelX = clientX - x
      pixelY = pixelY <= 0 ? 0 : pixelY >= bottom ? height : pixelY
      pixelX = pixelX <= 0 ? 0 : pixelX >= right ? width : pixelX

      let percentX = pixelX / width
      let percentY = pixelY / height
      percentX = percentX < 0 ? 0 : percentX > 1 ? 1 : percentX
      percentY = percentY < 0 ? 0 : percentY > 1 ? 1 : percentY

      clientX = percentX <= 0 ? x : percentX >= 1 ? right : clientX
      clientY = percentY <= 0 ? y : percentY >= 1 ? bottom : clientY

      const res = {
        y,
        x,
        bottom,
        clientX,
        clientY,
        percentX,
        percentY,
        pixelY,
        pixelX,
      }
      // console.log(res)
      return res
    },
  },
  computed: {
    handleStyle() {
      return {
        top: `${this.percentY * 100}%`,
        left: `${this.percentX * 100}%`,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.cusscrollbar {
  // --clr-back: var(--clr-black-2);
  // --clr-border: var(--clr-black-3);
  // --clr-back-handle: var(--clr-black-3);
  // --handle-radius: 0px;
  // --handle-radius: 4px;
  // --handle-radius: 99px;
  // --handle-radius: 8px;
  --size-handle: 2rem;
  --clr-handle-back: rgba(255, 255, 255, 0.125);
  --clr-handle-back-active: rgba(255, 255, 255, 0.25);

  --clr-inner-back: var(--clr-black-1-2);

  position: relative;
  // height: 100%;
  // width: 100%;
  // height: 666px;
  // width: 200px;
  // background: rgba(255, 0, 0, 0.318);
  flex-shrink: 0;
  cursor: pointer;
  touch-action: none;

  &_inner-wrapper {
    border-radius: 4px;
    // border: solid var(--clr-border) 1px;
    background: var(--clr-inner-back);
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    // overflow: hidden;
    height: 100%;
    width: 100%;
  }
  &_inner-on-top {
    z-index: 1;
  }
  &_inner,
  &_inner-on-top {
    position: absolute;
  }
  &_horizontal {
    --width-handle: var(--size-handle);
    --height-handle: 100%;
    .cusscrollbar_handle {
      transform: translate(-50%, 0);
    }
    .cusscrollbar_inner {
      width: calc(100% - (var(--width-handle)));
      height: 100%;
      top: 0;
      left: 0;
      left: calc(var(--width-handle) * 0.5);
    }
    .cusscrollbar_inner-on-top {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
  &_vertical {
    --width-handle: 100%;
    --height-handle: var(--size-handle);
    .cusscrollbar_handle {
      transform: translate(0, -50%);
    }
    .cusscrollbar_inner {
      height: calc(100% - var(--height-handle));
      width: 100%;
      top: calc(var(--height-handle) * 0.5);
      left: 0;
    }
    .cusscrollbar_inner-on-top {
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
    }
    // .cusscrollbar_inner,
    // .cusscrollbar_inner-on-top {
    // height: calc(100% - var(--height-handle));
    // width: 100%;
    // top: calc(var(--height-handle) * 0.5);
    // left: 0;
    // }
  }

  &:active {
    .cusscrollbar_handle {
      background: var(--clr-handle-back-active);
    }
  }
  &_handle {
    background: var(--clr-handle-back);
    border-radius: 4px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    // border-radius: var(--handle-radius);
    height: var(--height-handle);
    width: var(--width-handle);

    box-sizing: content-box;
    // border-top: solid var(--clr-border) 1px;
    // border-bottom: solid var(--clr-border) 1px;
    transition: background 0.15s;
  }
}
</style>
